import React, { Fragment } from "react";
import Header3 from "../../components/header3/Header3";
import Hero3 from "../../components/hero3/hero3";

import EmpoweringSuccess from "../../components/business-consulting-components/EmpoweringSuccess/EmpoweringSuccess";
import ConsultingService from "../../components/business-consulting-components/ConsultingService/ConsultingService";
import BusinessTestimonial from "../../components/business-consulting-components/BusinessTestimonial/BusinessTestimonial";

import BusinessContact from "../../components/business-consulting-components/BusinessContact/BusinessContact";
import BusinessFooter from "../../components/business-consulting-components/BusinessFooter/BusinessFooter";
import HomeBlogSection from "../../components/business-consulting-components/HomeBlogSection/HomeBlogSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import SEO from "../../components/seo/SEO";

const HomePage3 = () => {
  return (
    <Fragment>
      <SEO
        title="Leading Chartered Accountancy Firm in Delhi NCR – Binod Verma & Co."
        description="Providing end-to-end CA services in Delhi NCR – from tax planning and audits to IFRS consulting, compliance, and NGO advisory."
        keywords="Chartered Accountant Delhi, CA Firm NCR, Tax Planning Delhi, IFRS Consulting Delhi, NGO Compliance Delhi NCR, Audit Consultant Delhi, CA in Noida Gurgaon"
        canonical="https://www.binodverma.com/"
        ogImage="https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg"
        schemaMarkup={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "AccountingService",
              name: "Binod Verma & Co.",
              image:
                "https://ufs-net.s3.ap-south-1.amazonaws.com/demoInterview/og-image.jpg",
              description:
                "Chartered Accountant in Delhi NCR specializing in taxation, GST, audits, NGOs & accounting services.",
              address: {
                "@type": "PostalAddress",
                streetAddress: "Laxmi Nagar",
                addressLocality: "Delhi",
                addressRegion: "Delhi",
                postalCode: "110092",
                addressCountry: "India",
              },
              areaServed: ["Delhi", "Noida", "Gurgaon"],
              url: "https://www.binodverma.com",
            },
            {
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "Which is the best CA firm in Delhi for startups?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Binod Verma & Co. provides tax filing, GST, and audit solutions tailored for Delhi-based startups.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Do you provide NGO audit services in Noida?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, we specialize in NGO and society audits in Noida with compliance-focused services.",
                  },
                },
              ],
            },
          ],
        }}
      />
      <div className="index_business_consulting">
        <main className="page_content s2">
          <Header3 />
          <div style={{ marginTop: "-77px" }}>
            <Hero3 />
          </div>

          <HomeBlogSection />
          <ConsultingService />
          <EmpoweringSuccess />
          <BusinessTestimonial />

          <BusinessContact />
          <BusinessFooter />
          <Scrollbar />
        </main>
      </div>
    </Fragment>
  );
};
export default HomePage3;
